import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)


export default new Vuex.Store ({
    plugins: [createPersistedState()],

    state: {
        barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
        // barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-2.jpg',
        drawer: true,
        authorization: {}
    },

    mutations: {
        setBarImage(state, payload) {
            state.barImage = payload
        },
        setDrawer(state, drawer) {
            state.drawer = drawer
        },
        setAuthorization(state, auth) {
            state.authorization = auth
        }
    },
    getters: {
        getAuthorization: (state) => {
            return state.authorization
        },
        getUserId: (state) => {
            if (state.authorization !== null) {
                return state.authorization.userId
            }
        },
        getIsAuthenticated: (state) => {
            return state.authorization !== null
        },
        getUserStatusId: (state) => {
            if (state.authorization !== null) {
                return state.authorization.statusId
            }
        },
        getDrawer: (state) => {
            return state.drawer
        },
        getBarImage: (state) => {
            return state.barImage
        },
        getBarColor: (state) => {
            return state.barColor
        }
    },
    actions: {}
})
